export const routes = (isAdminInstitution, institutionId) => {

  let allRoutes = [
    {
      path: '/',
      icon: "fa fa-long-arrow-left",
      title: "До порталу"
    },
    {
      path: "/admin/documents",
      icon: "fa fa-file-text-o",
      title: "Документи"
    },
    {
      path: "/admin/mailing",
      icon: "fa fa-address-book",
      title: "Розсилки"
    },
    {
      path: "/admin/operators",
      icon: "fa fa-file",
      title: "Оператори"
    },
    {
      path: "/admin/institutions",
      icon: "fa fa-building",
      title: "Медичні установи"
    },
    {
      path: "/admin/services",
      icon: "fa fa-heartbeat",
      title: "Медичні послуги"
    },
    {
      path: "/admin/doctors",
      icon: "fa fa-user",
      title: "Облікові записи"
    },
    {
      path: "/admin/personal",
      icon: "fa fa-users",
      title: "Персонал"
    },
    {
      path: "/admin/news",
      icon: "fa fa-newspaper-o",
      title: "Новини"
    }
  ];

  let routesAdminInstitution = [
    {
      path: `/admin/institutions/detail/${institutionId}`,
      icon: "fa fa-building",
      title: "Медична установа"
    },
    {
      path: "/admin/doctors",
      icon: "fa fa-user",
      title: "Облікові записи"
    }
  ];

  return isAdminInstitution ? routesAdminInstitution : allRoutes
}



// WEBPACK FOOTER //
// ./src/admin/routes.js